module.exports = __webpack_public_path__ + "img/sponsor-mlashes.513227da.png";